<template>
  <section>
    <button
      class="btn btn-danger float-right"
      @click.prevent="openModal"
    >
      Nouveau ticket
    </button>

    <bs-modal
      ref="newCaseModal"
      :need-footer="false"
      :centered="true"
      :large="false"
    >
      <span slot="title">Envoyer un message au Pro</span>

      <div slot="body">
        <form @submit="submitForm">
          <div class="form-group">
            <label for="caseSubject">Destinataire</label>

            <select
              v-model="proId"
              class="form-control"
              required
            >
              <option
                disabled
                value=""
              >
                Selectionner le destinataire
              </option>
              <option
                v-for="pro in pros"
                :key="pro.id"
                :value="pro.id"
              >
                {{ pro.email }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="caseSubject">Titre</label>
            <input
              id="caseSubject"
              v-model="subject"
              type="text"
              class="form-control"
              placeholder="Sujet du message"
              required
            >
          </div>

          <div class="form-group">
            <label for="caseBody">Contenu</label>
            <textarea
              id="caseBody"
              v-model="message"
              class="form-control"
              rows="10"
              placeholder="Contenu du message"
              required
            />
          </div>

          <small
            id="passwordHelpBlock"
            class="form-text text-muted"
          >
            L'envoi du message au pro, créera un ticket qui vous sera assigné
          </small>

          <div class="form-group text-right mt-4">
            <button
              type="submit"
              class="btn btn-primary"
            >
              Envoyer le message
            </button>
          </div>
        </form>
      </div>
    </bs-modal>
  </section>
</template>

<script>
import Tls from "@/services/Tls";
import BsModal from "@/components/BsModal";
import { toastMessage } from "@/services/utils";

const initialData = () => ({
	subject: null,
	message: null,
	proId: "",
});

const data = () => initialData();

const openModal = function () {
	this.$refs.newCaseModal.openModal();
};

const closeModal = function () {
	this.$refs.newCaseModal.closeModal();
};

const submitForm = function(e) {
	e.preventDefault();

	const { subject, message, groupId, proId } = this;

	Tls.Cases.create({ groupId, message, subject, proId }).then(_ => {
		this.$emit("onCreate");

		closeModal.bind(this)();

		toastMessage("Message envoyé !");
      
		Object.assign(this.$data, initialData());
	});
};

export default {
	name: "NewCase",
	components: {
		BsModal
	},
	props: {
		groupId: {
			type: Number,
			required: true
		},
		pros: {
			type: Array,
			required: true
		}
	},
	data,
	methods: {
		openModal,
		submitForm
	}
};
</script>